import { environment } from '../../config/environments';

/**
 * Endpoints /{idProjeto} da API de permissões Geo360 por relatório.
 * O id na URL é do projeto; o tenant do usuário vai no header X-TN-TOKEN.
 * Relatórios sem projeto específico usam o projeto Mesquita 2090 (padrão interno).
 */
export const POWER_BI_GEO360_URLS = {
  Alexania: [`${environment.apiUserGeo360MesquitaPermission}/2090`],
  Amapa: [`${environment.apiUserGeo360MesquitaPermission}/2090`],
  Angra: [`${environment.apiUserGeo360MesquitaPermission}/2090`],
  AparecidaGoiania: [`${environment.apiUserGeo360MesquitaPermission}/2090`],
  Araguaina: [`${environment.apiUserGeo360MesquitaPermission}/2090`],
  Gurupi: [`${environment.apiUserGeo360MesquitaPermission}/2090`],
  Manaus: [`${environment.apiUserGeo360MesquitaPermission}/2610`],
  Mariana2022: [`${environment.apiUserGeo360MesquitaPermission}/2090`],
  Mariana2025: [`${environment.apiUserGeo360MesquitaPermission}/3603`],
  Mariana2025Financas: [`${environment.apiUserGeo360MesquitaPermission}/3603`],
  Maracanau: [`${environment.apiUserGeo360MesquitaPermission}/2090`],
  Parauapebas: [`${environment.apiUserGeo360MesquitaPermission}/2183`],
  RibeiraoNeves: [`${environment.apiUserGeo360MesquitaPermission}/2151`],
  RioBranco: [`${environment.apiUserGeo360MesquitaPermission}/2090`],
  Goiania: [`${environment.apiUserGeo360MesquitaPermission}/3702`, `${environment.apiUserGeo360GoianiaPermission}/3702`],
  GoianiaFinancas: [`${environment.apiUserGeo360MesquitaPermission}/3702`, `${environment.apiUserGeo360GoianiaPermission}/3702`],
  Codevasf: [`${environment.apiUserGeo360MesquitaPermission}/3395`],
  Codevasf_Producao: [`${environment.apiUserGeo360MesquitaPermission}/2090`],
  VitoriaConquista2022: [`${environment.apiUserGeo360MesquitaPermission}/2090`],
  VitoriaConquista2025: [`${environment.apiUserGeo360MesquitaPermission}/2090`],
  Vicosa: [`${environment.apiUserGeo360MesquitaPermission}/3581`],
  SaoBorja: [`${environment.apiUserGeo360MesquitaPermission}/3599`],
  Lagarto: [`${environment.apiUserGeo360MesquitaPermission}/2090`],
  CaxiasDoSul: [`${environment.apiUserGeo360MesquitaPermission}/2926`],
  PantanoGrande: [`${environment.apiUserGeo360MesquitaPermission}/2090`],
  NovaLima: [`${environment.apiUserGeo360MesquitaPermission}/2090`],
  Sabara: [`${environment.apiUserGeo360MesquitaPermission}/3215`],
  Saj: [`${environment.apiUserGeo360MesquitaPermission}/3128`],
  Palmas: [`${environment.apiUserGeo360MesquitaPermission}/2090`],
  Araraquara: [`${environment.apiUserGeo360MesquitaPermission}/3778`],
  AraraquaraFinancas: [`${environment.apiUserGeo360MesquitaPermission}/3778`],
  AraraquaraFinancasTodosCenarios: [`${environment.apiUserGeo360MesquitaPermission}/3778`],
  Abaetetuba: [`${environment.apiUserGeo360MesquitaPermission}/4004`],
  AbaetetubaFinancas: [`${environment.apiUserGeo360MesquitaPermission}/4004`],
  Seger: [`${environment.apiUserGeo360MesquitaPermission}/2090`],
  Horizonte: [`${environment.apiUserGeo360MesquitaPermission}/3712`],
  HorizonteFinancas: [`${environment.apiUserGeo360MesquitaPermission}/3712`],
  SeiBahia: [`${environment.apiUserGeo360MesquitaPermission}/2090`],
  Atividades: [`${environment.apiUserGeo360MesquitaPermission}/2090`],
  Aviacao: [`${environment.apiUserGeo360MesquitaPermission}/2090`],
  Cadastro: [`${environment.apiUserGeo360MesquitaPermission}/2090`],
  IndicadoresSociais: [`${environment.apiUserGeo360MesquitaPermission}/2090`],
  Producao: [`${environment.apiUserGeo360MesquitaPermission}/2090`],
  GerenciaExecucao: [`${environment.apiUserGeo360MesquitaPermission}/2090`],
  Custo: [`${environment.apiUserGeo360MesquitaPermission}/2090`],
  CustoProjetos: [`${environment.apiUserGeo360MesquitaPermission}/2090`],
  ComparativoIptuItbi: [`${environment.apiUserGeo360MesquitaPermission}/2090`],
  AvaliacaoMonitoramentoGoiania: [`${environment.apiUserGeo360MesquitaPermission}/2090`],
  AvaliacaoMonitoramentoVitoriaConquista: [`${environment.apiUserGeo360MesquitaPermission}/2090`],
  AvaliacaoMonitoramentoVicosa: [`${environment.apiUserGeo360MesquitaPermission}/2090`],
  AvaliacaoMonitoramentoHorizonte: [`${environment.apiUserGeo360MesquitaPermission}/2090`],
  MonitoramentoIntegracoes: [`${environment.apiUserGeo360MesquitaPermission}/2090`],
  AcessosGeo360: [`${environment.apiUserGeo360MesquitaPermission}/2090`],
  VisitasCampo: [`${environment.apiUserGeo360MesquitaPermission}/2090`],
  RelatorioCusto: [`${environment.apiUserGeo360MesquitaPermission}/2090`],
  SantanaDoParaiso: [`${environment.apiUserGeo360MesquitaPermission}/3872`],
  SantanaDoParaisoFinancas: [`${environment.apiUserGeo360MesquitaPermission}/3872`],
  Picos: [`${environment.apiUserGeo360MesquitaPermission}/4050`],
  PicosFinancas: [`${environment.apiUserGeo360MesquitaPermission}/4050`],
  PortopecemNelog: [`${environment.apiUserGeo360MesquitaPermission}/4052`],
  Tucuma: [`${environment.apiUserGeo360MesquitaPermission}/4048`],
} as const;

export type PowerBiGeo360ReportKey = keyof typeof POWER_BI_GEO360_URLS;
